import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7337 19H3.15286C1.96508 19 1 18.0319 1 16.766V7.23403C1 6.04256 1.96508 5 3.15286 5H14.8079C15.9957 5 16.9608 5.96809 16.9608 7.23403V16.8404C16.8865 18.0319 15.9215 19 14.7337 19ZM5.37996 8.0532C4.63759 8.20212 4.04368 8.79788 3.82098 9.61703C3.52403 11.0319 4.71181 12.2979 6.12231 12C6.86467 11.8511 7.45854 11.1809 7.68127 10.3617C8.05245 8.87235 6.86469 7.68085 5.37996 8.0532ZM21.9497 17.2371L18.8738 15.4362C18.2736 15.061 17.8235 14.7609 17.8235 14.1606V10.0336C17.8235 9.43333 18.2736 9.13319 18.8738 8.83305L21.9497 7.03216C22.5499 6.65696 23 6.9571 23 7.55741V16.7869C22.925 17.3871 22.4748 17.6123 21.9497 17.2371Z"
      fill="currentColor"
    />
  </svg>
);
